module.exports = __webpack_public_path__ + "static/media/Purchase3.59efff6c.png";